/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-integration-template.reducer';

export const TenantIntegrationTemplateDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantIntegrationTemplateEntity = useAppSelector(state => state.tenantIntegrationTemplate.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantIntegrationTemplateDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.detail.title">TenantIntegrationTemplate</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationTemplateEntity.id}</dd>
          <dt>
            <span id="messageFormat">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.messageFormat">Message Format</Translate>
            </span>
            <UncontrolledTooltip target="messageFormat">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.messageFormat" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationTemplateEntity.messageFormat}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationTemplateEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationTemplateEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationTemplateEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationTemplateEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationTemplateEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.template">Template</Translate>
          </dt>
          <dd>{tenantIntegrationTemplateEntity.template ? tenantIntegrationTemplateEntity.template.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-integration-template" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-integration-template/${tenantIntegrationTemplateEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantIntegrationTemplateDetail;
